"use client"

import type { ServiceGridListProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { twMerge } from "tailwind-merge"
import { useMemo } from "react"
import { generateResponsiveCSS } from "../../../lib/helper"
import { ServiceGridListContent } from "./components/ServiceGridListContent"

export const RenderConfig: ComponentConfig<ServiceGridListProps> = {
  render: ({
    title,
    items,
    className,
    styles,
    responsiveType,
    id: componentId,
  }: ServiceGridListProps & { id?: string }) => {
    const id = useMemo(
      () => componentId || `service-grid-list-${Math.random().toString(36).substring(2, 9)}`,
      [componentId],
    )

    const mergedStyles = styles || {}
    const responsiveCSS = generateResponsiveCSS(id, mergedStyles, responsiveType || "mobileFirst")

    return (
      <>
        {responsiveCSS}
        <ServiceGridListContent id={id} title={title} items={items} className={twMerge(className)} />
      </>
    )
  },
}
